import { ScanDataFileStatusType } from '@occc/graphql';
import { UseSearchParamsParameters } from '@occc-app/hooks/useSearchParams';
import { UseAdvancedQueryParamParams } from '@occc/utils';
import { UsePaginationProps } from '@occc-app/hooks/usePaginationParams';
import { formatDateTime } from '@occc-app/lib/date';

import { isAValidDate, parseStringToDate } from '../scan-data-weekly-file.utils';

export const PAST_SUBMISSIONS_DEFAULT_STATUS = 'all';

export const pastSubmissionsSearchParams: UseSearchParamsParameters = {
  searchParamName: 'past-submissions-search',
  beforeParamName: 'past-submissions-before',
  afterParamName: 'past-submissions-after',
};

export const dateParamName = 'allow-list-start-date';

export const defaultDateQueryParams: UseAdvancedQueryParamParams<Date | undefined> = {
  paramName: dateParamName,
  beforeParamName: pastSubmissionsSearchParams.beforeParamName,
  afterParamName: pastSubmissionsSearchParams.afterParamName,
  defaultValue: undefined,
  readValidator: isAValidDate,
  parse: parseStringToDate,
  format: formatDateTime,
};

const statusParamName = 'scan-data-status';
export const defaultStatusQueryParams: UseAdvancedQueryParamParams<ScanDataFileStatusType | 'all'> =
  {
    paramName: statusParamName,
    allowedValues: Object.values(ScanDataFileStatusType),
    defaultValue: PAST_SUBMISSIONS_DEFAULT_STATUS,
    beforeParamName: pastSubmissionsSearchParams.beforeParamName,
    afterParamName: pastSubmissionsSearchParams.afterParamName,
  };

const PAGINATION_PAGE_SIZE = 10;

export const defaultPaginationParams: UsePaginationProps = {
  beforeParamName: pastSubmissionsSearchParams.beforeParamName,
  afterParamName: pastSubmissionsSearchParams.afterParamName,
  pageSize: PAGINATION_PAGE_SIZE,
};
